import http from "../../../services/http";
import { updateUser } from "../../auth/authReducer";

const path = "api/settings/professor";
const profile_update_path = "api/create/media";

const classSettings = ({ onSuccess, onError, onEnd, id, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/class/${id}`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const classStudentNotification = ({ onSuccess, onError, onEnd, id, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/classnotification/${id}`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const classActivitySettings = ({ onSuccess, onError, onEnd, id, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/classactivity/${id}`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const sectionEdit = ({ onSuccess, onError, onEnd, id, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/section/${id}`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const accountInfo = ({ onSuccess, onError, onEnd, body, id = "" }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/profile/account`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const profileInfo = ({ onSuccess, onError, onEnd, body, id = "" }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/profile/info`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const notification = ({ onSuccess, onError, onEnd, body, id = "" }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/profile/notifications`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const getSignedUrl =
  ({ body, onSuccess, onError, onEnd }) =>
  async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: profile_update_path,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      const user = res.data.data;
      if (onSuccess) onSuccess(user);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };

// const uploadProfileImage = ({ body, onSuccess, onError, onEnd }) =>
//     async(dispatch, getState) => {
//         try {
//             const res = await http.put({

//             });
//         } catch (error) {
//             if (onError) onError(error);
//         } finally {
//             if (onEnd) onEnd();
//         }
//     };

export {
  classSettings,
  sectionEdit,
  accountInfo,
  profileInfo,
  notification,
  getSignedUrl,
  // uploadProfileImage,
  classActivitySettings,
  classStudentNotification,
};
